import React from 'react';
import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import Logo from '@/assets/images/LOGO/QODEARIS (2).svg';

const { Title, Text } = Typography;

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img 
                src={Logo} 
                alt="QodeAris Logo" 
                className="h-10 w-auto"
              />
            </Link>
            <Title level={4} className="text-white mb-2">QodeAris</Title>
            <Text className="text-gray-400 block mb-3">
              Agritech Innovation for Indian Farmers
            </Text>
            <Text className="text-gray-500 text-sm">
              Featuring DhartiNetra – Farm Rakshak
            </Text>
          </div>
          <div>
            <Title level={5} className="text-white mb-4">Contact</Title>
            <div className="space-y-2 text-gray-400">
              <div>📧 hello@qodearis.com</div>
              <div>📞 +91 98226 28174</div>
              <div>🌐 www.qodearis.com</div>
            </div>
          </div>
          <div>
            <Title level={5} className="text-white mb-4">Address</Title>
            <Text className="text-gray-400">
              3rd Floor, Hashtag, Hinjawadi Phase 1,<br />
              Maan Road, Pune – 411057, India
            </Text>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 text-center">
          <Text className="text-gray-400">
            © {new Date().getFullYear()} QodeAris. All rights reserved.
          </Text>
        </div>
      </div>
    </footer>
  );
};
